import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer, Subject } from "rxjs";
import { ApiService } from "../services/api.service";
import { ApiServiceDelegate } from "../models/api-service-delegate";
import { NzMessageService } from "ng-zorro-antd/message";
import { LoginComponent } from "../login/login.component";
import { ApiCollection } from "../providers/api-collection";
import { AppCommon } from "../providers/app-common";
import LoginModel from "../models/user.model";

 
 

@Injectable({
    providedIn: "root",
})

export class LoginViewModel {

    parentLoginComponent: LoginComponent | undefined;

    loginModel = new BehaviorSubject<LoginModel>(new LoginModel());

    constructor(
        private apiService: ApiService,
        private message: NzMessageService
    ) {

    }


    subscribeLogin(
        observer: Observer<LoginModel>
    ) {
        this.loginModel.subscribe(observer)
    }


    authenticate(token) {
        let d: ApiServiceDelegate = {
            Data: { token: token },
            Method: "POST",
            Action: ApiCollection.SIGN_IN,
            Success: (e: any) => {
                if (e.status === true) {
                    AppCommon.setLoggedInObject(e);
                    this.loginModel.next(e);
                    this.parentLoginComponent.loginSuccess();
                    this.message.success("Logged in successfully", { nzDuration: 1000 });
                } else {
                    this.message.error("Login error", { nzDuration: 1000 });
                    console.log("login error");
                }
                return e;
            },
            Error: (e: any) => {
                this.message.error(e, { nzDuration: 1000 })
                return e;
            },
        };
        this.apiService.callService(d);
    }



}
